export const Icon = () => {
    return (
        <svg width="84" height="84" viewBox="0 0 84 84" fill="none" stroke="#D4BC87">
            <path d="M52.0666 14.2915C19.798 9.90265 13.9817 34.0437 18.213 47.7605C26.2521 30.2026 42.0183 26.9112 48.8965 27.4602C25.1977 29.2159 18.9203 58.5516 18.744 73H25.0919C24.6687 69.9274 25.9736 62.5752 26.6789 59.2832C68.1518 72.4513 74.6381 32.5811 72.6971 11C64.6564 15.8283 55.5932 15.2061 52.0666 14.2915Z" />
        </svg>
    );
};
